import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  AppBar,
  Box,
  Toolbar,
  IconButton,
  Typography,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  ListItemIcon,
  Divider,
} from '@mui/material';
import {
  Dashboard,
  Person,
  Factory,
  ShoppingCart,
  Close,
  Logout as LogoutIcon,
  Settings,
  CurrencyExchange,
  BarChart,
  Inventory,
} from '@mui/icons-material';
import { Actions, useDispatchProvider, useStateDrawerMenu, useStateUser } from '../utils/StateProvider';
import { usePermissions } from '../utils/AclProvider';
import { getNestedObject } from '../../utils/utils';
import { signOut } from 'firebase/auth';
import { auth } from '../../config/firebase';

const DrawerMenu = () => {
  const navigate = useNavigate();
  const stateDrawerMenu = useStateDrawerMenu();
  const stateUser = useStateUser();
  const permissions = usePermissions();
  const dispatch = useDispatchProvider();
  const handleDrawerClose = () => {
    dispatch && dispatch({ type: Actions.DrawerMenu, payload: false });
  };

  const menuItems = [
    { title: 'Dashboard', path: '/', icon: <Dashboard /> },
    { title: 'Orders', path: '/orders', requiredPermission: 'orders.read', icon: <ShoppingCart /> },
    { title: 'Products', path: '/products', requiredPermission: 'products.read', icon: <Inventory /> },
    { title: 'Customers', path: '/customers', requiredPermission: 'customers.read', icon: <Person /> },
    { title: 'Suppliers', path: '/suppliers', requiredPermission: 'suppliers.read', icon: <Factory /> },
  ];

  const adminItems = [
    { title: 'Settings', path: '/settings', requiredPermission: 'settings.read', icon: <Settings />, security: false },
    {
      title: 'Transactions',
      path: '/transactions',
      requiredPermission: 'transactions.read',
      icon: <CurrencyExchange />,
      security: true,
    },
    {
      title: 'Logistics',
      path: '/logistics',
      requiredPermission: 'transactions.read',
      icon: <BarChart />,
      security: true,
    },
  ];

  const navigateTo = (path) => {
    navigate(path);
    dispatch && dispatch({ type: Actions.DrawerMenu, payload: false });
  };

  const logout = () => {
    signOut(auth)
      .then(() => {
        navigate('/login');
      })
      .catch((error) => {});
  };

  return (
    <Drawer
      open={stateDrawerMenu}
      onClose={handleDrawerClose}
    >
      <Box sx={{ width: '336px' }}>
        <AppBar position="sticky">
          <Toolbar color={'none'}>
            <IconButton
              size="large"
              edge="start"
              color="inherit"
              aria-label="close"
              sx={{ mr: 2, ml: -2.5 }}
              onClick={handleDrawerClose}
            >
              <Close />
            </IconButton>
            <Typography
              variant="h6"
              component="div"
              sx={{ flexGrow: 1 }}
            >
              Menu
            </Typography>
          </Toolbar>
        </AppBar>
        <List>
          {menuItems.map((item) => (
            <ListItem
              key={item.title}
              disablePadding
            >
              <ListItemButton
                onClick={() => navigateTo(item.path)}
                disabled={
                  item.requiredPermission && permissions && !getNestedObject(permissions, item.requiredPermission)
                }
              >
                <ListItemIcon>{item.icon}</ListItemIcon>
                <ListItemText primary={item.title} />
              </ListItemButton>
            </ListItem>
          ))}
          <Divider />
          {adminItems.map((item) => {
            if (!item.security || (item.security && stateUser.security))
              return (
                <ListItem
                  key={item.title}
                  disablePadding
                >
                  <ListItemButton
                    onClick={() => navigateTo(item.path)}
                    disabled={
                      item.requiredPermission && permissions && !getNestedObject(permissions, item.requiredPermission)
                    }
                  >
                    <ListItemIcon>{item.icon}</ListItemIcon>
                    <ListItemText primary={item.title} />
                  </ListItemButton>
                </ListItem>
              );
          })}
          <Divider />
          <ListItem
            disablePadding
            sx={{ mt: 'auto' }}
          >
            <ListItemButton onClick={logout}>
              <ListItemIcon>
                <LogoutIcon />
              </ListItemIcon>
              <ListItemText primary={'Logout'} />
            </ListItemButton>
          </ListItem>
        </List>
      </Box>
    </Drawer>
  );
};

export default DrawerMenu;
